import {
  InputField,
  LoaderButton
} from 'components/molecules'
import UrlRewruteFormSchema from 'domains/url-rewrite/organisms/form/url-rewrite-form-schema'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'

const propTypes = {
  urlRewrite: PropTypes.shape({
    old_path : PropTypes.string,
    new_path : PropTypes.string
  }),
  buttonText       : PropTypes.string,
  handleSubmitForm : PropTypes.func.isRequired
}

const defaultProps = {
  urlRewrite: {
    old_path : '',
    new_path : ''
  },
  buttonText       : '',
  handleSubmitForm : () => {}
}

/**
 * Form to create and edit Url Rewrite
 */

const UrlRewriteForm = ({
  urlRewrite,
  buttonText,
  handleSubmitForm
}) =>  (
  <Formik
    enableReinitialize={ true }
    initialValues={ urlRewrite }
    validationSchema={ UrlRewruteFormSchema }
    onSubmit={ handleSubmitForm }
  >
    {
      (formikBag) => (
        <>
          <Form>

            <InputField
              type='text'
              name='old_path'
              label='Old Path'
              placeholder='katalog'
              required={ true }
            />

            <InputField
              type='text'
              name='new_path'
              label='New Path'
              placeholder='wanita'
              required={ true }
            />

            <LoaderButton
              className='float-right'
              color='success'
              isLoading={ formikBag.isSubmitting }
              onClick={ formikBag.submitForm }
              text={ buttonText }
            />
          </Form>
        </>
      )
    }
  </Formik>
)


UrlRewriteForm.propTypes    = propTypes
UrlRewriteForm.defaultProps = defaultProps

export default UrlRewriteForm
